import { render } from "./AddPersonnel.vue?vue&type=template&id=5a9c2e51&scoped=true&ts=true"
import script from "./AddPersonnel.vue?vue&type=script&lang=ts"
export * from "./AddPersonnel.vue?vue&type=script&lang=ts"

import "./AddPersonnel.vue?vue&type=style&index=0&id=5a9c2e51&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a9c2e51"]])

export default __exports__